<template>
  <div>
    <Select
      v-model="order.chainSystemProductID"
      :placeholder="$t('orderLine.chainSystem')"
      clearable
      :options="operationProducts"
      value-field="id"
      label-field="description"
      class="search-select"
      style="padding-bottom:10px"
      @input="handleChainSystemChange"
    />
    <Select
      v-model="order.chainProductID"
      :placeholder="$t('orderLine.chainProduct')"
      clearable
      :options="products.filter(p => p.productTypeOption === productTypeOption.Chain)"
      value-field="id"
      label-field="description"
      class="search-select"
      style="padding-bottom:10px"
      @input="handleChainChange"
    />
    <Select
      v-model="order.operationSide"
      :placeholder="$t('orderLine.operationSide')"
      clearable
      :options="operationOptions"
      value-field="code"
      label-field="description"
      class="search-select"
    />
    <MDinput
      v-model="order.finishedWidthLeftInCm"
      type="number"
      :required="false"
      :maxlength="16"
      :precision="1"
      @input="emitValues"
    >
      {{ $t('orderLine.width') }}
    </MDinput>
    <MDinput
      v-model="order.assemblyHeightInCm"
      type="number"
      :required="false"
      :maxlength="16"
      :precision="1"
      @input="emitValues"
    >
      {{ $t('orderLine.assemblyHeight') }}
    </MDinput>
  </div>
</template>

<script>
import MDinput from '@/components/MDinput';
import Select from '@/components/DSE/Select';
import { ProductTypeOption } from '@/utils/constants';
import { FinishTypeOption } from '@/utils/constants';

export default {
  name: 'CreateRomanBlind',
  components: {
    MDinput,
    Select
  },
  props: {},
  data() {
    return {
      order: {},
      productTypeOption: ProductTypeOption,
      finishTypeOption: FinishTypeOption
    };
  },
  computed: {
    products() {
      return this.$store.getters['product/loadedItems'];
    },
    operationProducts() {
      const operationProductTypeIDs = this.$store.getters['finishType/loadedItems']
        .filter(ft => ft.finishTypeOption === this.finishTypeOption.Operation)
        .map(ft => ft.requiredProductTypeID);
      return this.products.filter(p => operationProductTypeIDs.includes(p.productTypeID));
    },
    operationOptions() {
      return this.$store.getters['option/loadedOptions']('operationSide');
    }
  },
  watch: {},
  created() {},
  methods: {
    handleChainSystemChange(id) {
      if (id) {
        const product = this.products.find(p => p.id === id);
        const finishType = this.$store.getters['finishType/loadedItems'].find(
          ft => ft.requiredProductTypeID === product.productTypeID
        );
        this.order.chainSystemFinishTypeID = finishType.id;
      }
      this.emitValues();
    },
    handleChainChange(id) {
      if (id) {
        const product = this.products.find(p => p.id === id);
        const finishType = this.$store.getters['finishType/loadedItems'].find(
          ft => ft.requiredProductTypeID === product.productTypeID
        );
        this.order.chainFinishTypeID = finishType.id;
      }
      this.emitValues();
    },
    emitValues() {
      this.$emit('input', this.order);
    }
  }
};
</script>
<style lang="scss"></style>
